import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { TableBody } from '@material-ui/core';
import enabledStripeBilling from '../../constants/StripeBilling';

const styles = {
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  }
};

const enhance = compose(connect());

const ShopTable = enhance(
  ({
    classes,
    menuId,
    menuName,
    price,
    taxTypeStr,
    reducedTaxTypeStr,
    description,
    createdAt,
    updatedAt,
    tags,
    image,
    comboMenu,
    priceCombo,
    quantityRelease,
    quantityPromotion,
    promotionDescription,
    subscription,
    subscriptionIntervalCount,
    subscriptionInterval,
    usageLimit,
    expiration,
    expirationEndDate,
    genreName,
    situationNames,
    userTargetNames,
    menuLimitTotal,
    menuChildType,
    isFukuoka
  }) => {
    return (
      <Table className={classes.detailTable}>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              {isFukuoka ? 'コースID' : 'メニューID'}
            </TableCell>
            <TableCell className={classes.tableCellData}>{menuId}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              {isFukuoka ? 'コース名' : 'メニュー名'}
            </TableCell>
            <TableCell className={classes.tableCellData}>{menuName}</TableCell>
          </TableRow>
          {menuChildType !== 5 && !isFukuoka && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>区分</TableCell>
              <TableCell className={classes.tableCellData}>
                {comboMenu === 0 ? '普通' : '回数券'}
              </TableCell>
            </TableRow>
          )}
          {comboMenu === 0 && menuChildType !== 5 && !isFukuoka && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用方法</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuLimitTotal === 1 ? '一円単位利用' : '一枚単位利用'}
              </TableCell>
            </TableRow>
          )}
          {comboMenu === 1 && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  単価 × 発行枚数
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${priceCombo}円ｘ${quantityRelease}枚`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  付与無料枚数
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {quantityPromotion ? `${quantityPromotion}枚` : ''}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>おまけ</TableCell>
                <TableCell className={classes.tableCellData}>
                  {promotionDescription}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用制限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {usageLimit === 1 ? '1日1枚' : 'なし'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用期限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {expiration ? `${expiration}日間` : expirationEndDate}
                </TableCell>
              </TableRow>
            </>
          )}
          {subscription === 1 && enabledStripeBilling === true && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  サブスクチケット
                </TableCell>
                <TableCell className={classes.tableCellData}>✔</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  購入頻度
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${subscriptionIntervalCount}${
                    subscriptionInterval === 'WEEK' ? '週間' : 'ヶ月'
                  }1回`}
                </TableCell>
              </TableRow>
            </>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              {isFukuoka ? '金額' : '価格'}
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {price}
              {`円`}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              {isFukuoka ? '税区分' : '税区分'}
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {taxTypeStr}
            </TableCell>
          </TableRow>
          {!isFukuoka && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  軽減税率対象
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {reducedTaxTypeStr}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  ジャンル
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {genreName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  シチュエーション
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {situationNames}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  贈り相手
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {userTargetNames}
                </TableCell>
              </TableRow>
            </>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>説明</TableCell>
            <TableCell className={classes.tableCellData}>
              {description}
            </TableCell>
          </TableRow>
          {!isFukuoka && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                <div>
                  {tags.map(tag => {
                    return <span className={classes.tag}>{tag.tagName}</span>;
                  })}
                </div>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>画像</TableCell>
            <TableCell className={classes.tableCellData}>
              <Card className={classes.userImage}>
                <CardActionArea>
                  <CardMedia component="img" image={image} />
                </CardActionArea>
              </Card>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>登録日時</TableCell>
            <TableCell className={classes.tableCellData}>{createdAt}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>更新日時</TableCell>
            <TableCell className={classes.tableCellData}>{updatedAt}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
